import { useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import { FormGroup, FormControlLabel, Checkbox, Button, CircularProgress } from "@mui/material";
/* hooks */
import { useDadoComplementarStore } from "store/useDadoComplementarStore";
import { usePublicoTurma } from "./hooks/usePublicoTurma";
import { useAppFeedback } from "hooks/useAppFeedback";
/* components */
import MultiSelectCheck from "components/atoms/MultiSelectField/MultSelectCheck";
import MultiSelectTransferField from "components/atoms/MultiSelectField/MultiSelectTransferField";
/* styles */
import styles_grid from "../../../styles/Grid.module.css";
import styles_general from "../../../styles/General.module.css";
import styles_button from "../../../styles/Button.module.css";

interface TurmaPublicoFormProps {
  onSaveSuccess?: () => void;
}

const TurmaPublicoForm = ({ onSaveSuccess }: TurmaPublicoFormProps) => {

  const [searchParams] = useSearchParams();
  const turmaId = searchParams.get("id");
  const { showError, showSuccess } = useAppFeedback();

  const {
    lotacoes,
    areasAtuacao,
    orgaosAtuacao,
    funcoesDesempenhadas,
  } = useDadoComplementarStore();

  const {
    msgError,
    msgSuccess,
    loadingPublico,
    loadingSave, 
    ambitoEstadual,
    ambitoMunicipal,
    selectedLotacoes,
    selectedOrgaos,
    selectedAreas,
    selectedFuncoes,
    handleChangeSelect,
    handleChangeCheckMunicipal,
    handleChangeCheckEstadual,
    savePublicoTurma,
  } = usePublicoTurma(turmaId);

  useEffect(() => {
    if (msgSuccess) {
      showSuccess(msgSuccess);
    }
  }, [msgSuccess, showSuccess]);

  useEffect(() => {
    if (msgError) {
      showError(msgError);
    }
  }, [msgError, showError]);

  if (loadingPublico) {
    return <CircularProgress />;
  }

  return (
    <>
      <div className={`${styles_general.mt2} ${styles_general.p2} ${styles_grid.grid12}`}>
        <div className={styles_grid.inputGroup4}>
          <FormGroup>
            <FormControlLabel control={
                <Checkbox 
                  checked={ambitoMunicipal} 
                  onChange={handleChangeCheckMunicipal} 
                />
              } label="Municipal (órgão)"
            />
            <FormControlLabel control={
                <Checkbox 
                  checked={ambitoEstadual} 
                  onChange={handleChangeCheckEstadual}
                />
              } label="Estadual (lotação)" 
            />
          </FormGroup>
        </div>
        
        {ambitoEstadual && (
          <div className={styles_grid.inputGroupFull}>
            <MultiSelectCheck
              label="Lotações *"
              placeholder="Selecione no mínimo uma lotação"
              fullWidth
              value={selectedLotacoes.map((d) => d)}
              onChange={(value: (string | number)[]) => {handleChangeSelect(value, 'lotacoes');}}
              options={lotacoes}
              required
            />
          </div>
        )}

        {ambitoMunicipal && (
          <div className={styles_grid.inputGroupFull}>
            <MultiSelectCheck
              label="Orgãos de Atuação *"
              placeholder="Selecione no mínimo um órgão de atuação"
              fullWidth
              value={selectedOrgaos.map((d) => d)}
              onChange={(value: (string | number)[]) => {handleChangeSelect(value, 'orgaos');}}
              options={orgaosAtuacao}
              required
            />
          </div>
        )}

        <div className={styles_grid.inputGroupFull}>
          <MultiSelectTransferField
            label="Áreas de Atuação *"
            placeholder="Selecione no mínimo uma área de atuação"
            fullWidth
            value={selectedAreas.map((d) => d)}
            onChange={(value: (string | number)[]) => {handleChangeSelect(value, 'areas');}}
            options={areasAtuacao}
            required
          />
        </div>

        <div className={styles_grid.inputGroupFull}>
          <MultiSelectCheck
            label="Funções Desempenhadas *"
            placeholder="Selecione no mínimo uma função"
            fullWidth
            value={selectedFuncoes.map((d) => d)}
            onChange={(value: (string | number)[]) => {handleChangeSelect(value, 'funcoes');}}
            options={funcoesDesempenhadas}
            required
          />
        </div>

        <div className={`${styles_grid.inputGroupFull} ${styles_grid.justifyCenter} ${styles_general.mt2}`}>
          {/* Pesquisar */}
          <Button
            variant="contained"
            onClick={async () => {
              const success = await savePublicoTurma();
              if (success) {
                onSaveSuccess?.();
              }
            }}
            className={`${styles_button.buttonPrimary} ${(loadingSave) ? styles_button.buttonLoad : ''} `}
            color="primary"
          >
            {loadingSave ? (
              <>
              <div className={styles_button.spinner}></div>
              <span>Salvando...</span>
              </>
            ) : (
            <span>Salvar Público da Turma</span>
            )}
          </Button>                
        </div>
    
      </div>
    </>
  );

};

export default TurmaPublicoForm;
